import { create } from 'zustand';
import { getState, useState } from '@/framework';
import { SHOW_RULER_BAR_STORAGE_KEY, type IExportState, type StateType } from '@/version-types';
import type { RulerUnit } from '../types';

/** 状态 */
interface IState {
    /** 是否显示标尺 */
    showRulerBar: boolean;
    /** 标尺单位 */
    rulerUnit: RulerUnit;
}

/** 动作 */
interface IAction {
    /** 设置启用、禁用标尺 */
    setShowRulerBar: (show: boolean) => void;
    /** 设置标尺单位 */
    setRulerUnit: (unit: RulerUnit) => void;
}

/** 存储类型 */
interface IStore extends IState, IAction {}

const getShowRulerBarKey = (identity: string) => {
    return SHOW_RULER_BAR_STORAGE_KEY + identity;
};

export const getLocalShowRulerBar = (identity: string) => {
    return localStorage.getItem(getShowRulerBarKey(identity)) === 'true';
};

const setLocalShowRulerBar = (identity: string, show: boolean) => {
    localStorage.setItem(getShowRulerBarKey(identity), show.toString());
};

/** 创建存储 */
const createState = (identity: string) => {
    const store = create<IStore>((set) => ({
        showRulerBar: getLocalShowRulerBar(identity),
        setShowRulerBar(show) {
            setLocalShowRulerBar(identity, show);
            set({ showRulerBar: show });
        },
        rulerUnit: 'px',
        /** 设置标尺单位 */
        setRulerUnit(unit) {
            set({ rulerUnit: unit });
        },
    }));

    return store;
};

/** 存储名称 */
const name = 'ruler-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取存储 */
export const useRulerState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getRulerState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

const exportState: IExportState = {
    name,
    createState,
};

export default exportState;
